import { CircularProgress } from '@mui/material'
import clsx from 'clsx'
import { Input, InputCheck, Slide, SubTags, TagBox } from 'components'
import { Icons, PeopleMyTagsParentItem, TagsProps } from 'interfaces'
import React, { useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import { configGenaral } from 'utils'

export const Tags: React.FC<TagsProps> = ({
	data,
	isLoading,
	totalList,
	resetInput,
	setTotalList,
	fetchNextPage,
	isFetchingNextPage,
	handleChangeDebounce,
	defaultOpenParent = false,
	setTagId,
	dataTagBox,
	isLoadingTagBox,
	fetchNextPageReach,
	hasNextPageReach,
	isFetchingNextPageReach,
	handleChangeDebounceReach,
	resetInputReach,
	hasPressDetails = true,
	fullHeight = false
}): JSX.Element => {
	const { ref, inView } = useInView()
	const [search, setSearch] = useState('')
	const [searchTags, setSearchTags] = useState('')
	const [listTags, setListTags] = useState<number[]>(totalList.tags)
	const [isOpenTagBoxModal, setIsOpenTagBoxModal] = useState(false)
	const [listTagsParents, setListTagsParents] = useState<
		PeopleMyTagsParentItem[]
	>([])

	const [tagTitle, setTagTitle] = useState<string | null>(null)

	useEffect(() => {
		if (inView) {
			if (
				data &&
				data.pages[0] &&
				data.pages[0].pages > data.pageParams.length
			) {
				fetchNextPage()
			}
		}
	}, [inView])

	useEffect(() => {
		if (data?.pages) {
			let aux = [] as PeopleMyTagsParentItem[]
			data.pages.forEach(page => {
				if (page) {
					aux = [...aux, ...page.items]
				}
				setListTagsParents(aux)
			})
		}
	}, [data])

	useEffect(() => {
		setTotalList({
			...totalList,
			tags: listTags
		})
	}, [listTags])

	const handleClose = (): void => {
		setSearchTags('')
		resetInputReach?.()
		setSearch('')
		resetInput?.()
		setIsOpenTagBoxModal(false)
	}

	return (
		<div>
			<Input
				name="search"
				placeholder="Search Tags"
				className="w-full !p-[unset]"
				onChangeCustom={e => {
					setSearch(e.target.value)
					handleChangeDebounce(e)
				}}
				rightIcon={Icons.cancel}
				rightClick={() => {
					resetInput()
					setSearch('')
				}}
				value={search}
				maxLength={configGenaral.maxSearchValue}
				inputClassName="!p-[unset] !py-1 !px-2"
				inputFocus
				borderFull={false}
				search
			/>

			<div className="mt-2">
				{isLoading ? (
					<div className="flex items-center justify-center w-full h-[400px] py-2 px-1 ">
						<CircularProgress disableShrink />
					</div>
				) : (
					<div
						className={clsx(
							fullHeight ? 'h-full' : 'max-h-[370px] overflow-y-auto'
						)}
					>
						{listTagsParents
							?.slice()
							.sort((a, b) =>
								a.name && b.name ? a.name.localeCompare(b.name) : 0
							)
							.map(item =>
								item.count_son > 0 ? (
									<SubTags
										tag={item}
										list={listTags}
										setList={setListTags}
										key={item.organization_tag_parent_id}
										defaultOpenParent={defaultOpenParent}
										classNameButtonReach={clsx(
											hasPressDetails ? 'cursor-pointer' : 'cursor-default'
										)}
										setIsOpenTagBoxModal={(
											openSlide: boolean,
											id: number,
											title: string
										) => {
											if (hasPressDetails) {
												setIsOpenTagBoxModal(openSlide)
												setTagId?.(id)
												setTagTitle(title)
											}
										}}
									/>
								) : (
									<InputCheck
										list={listTags}
										title={item.name}
										setList={setListTags}
										reach={item.num_users}
										className="mb-4 w-full"
										id={item.organization_tag_parent_id}
										key={item.organization_tag_parent_id}
										name={`${item.name}-${item.organization_tag_parent_id}`}
										isVisible={item.is_visible}
										isStrong
										hasCheckVisible
										classNameButtonReach={clsx(
											hasPressDetails ? 'cursor-pointer' : 'cursor-default'
										)}
										setIsOpenTagBoxModal={(
											openSlide: boolean,
											id: number,
											title: string
										) => {
											if (hasPressDetails) {
												setIsOpenTagBoxModal(openSlide)
												setTagId?.(id)
												setTagTitle(title)
											}
										}}
									/>
								)
							)}
						<div className="flex flex-col items-center" ref={ref}>
							{isFetchingNextPage && <CircularProgress disableShrink />}
						</div>
					</div>
				)}
			</div>
			<Slide
				setOpen={handleClose}
				open={isOpenTagBoxModal}
				title="Tag Reach"
				className="!max-w-[500px]"
			>
				<TagBox
					resetInput={resetInputReach}
					handleChangeDebounce={handleChangeDebounceReach}
					tagTitle={tagTitle}
					setSearchTags={setSearchTags}
					searchTags={searchTags}
					dataTagBox={dataTagBox}
					isLoadingTagBox={isLoadingTagBox}
					onClose={() => setIsOpenTagBoxModal(false)}
					fetchNextPageReach={fetchNextPageReach}
					hasNextPageReach={hasNextPageReach}
					isFetchingNextPageReach={isFetchingNextPageReach}
				/>
			</Slide>
		</div>
	)
}
